import {
  CallIcon,
  ChatBubbleIcon,
  Color,
  FavoriteIcon,
  MailIcon,
  NewsIcon,
  PhoneDisabledIcon
} from "@bonliva-crm/ui";
import { IconButton, Tooltip, Typography, makeStyles } from "@material-ui/core";
import {
  EventLogActionType,
  EventLogInputType,
  EventLogTextType
} from "../utils/event-log-input-type";

type Props = {
  badgeType: EventLogInputType;
  label: string;
  selected?: boolean;
  setSelected?: (selected: boolean) => void;
  onClick?: () => void;
  disabledReason?: string;
};

export const InputBadge = ({
  badgeType,
  label,
  selected,
  setSelected,
  onClick,
  disabledReason
}: Props) => {
  const classes = useStyles({
    selected,
    isActionButton: Object.values(EventLogActionType).includes(
      badgeType as EventLogActionType
    )
  });

  const icon = (() => {
    switch (badgeType) {
      case EventLogTextType.Call:
        return <CallIcon className={classes.icon} />;
      case EventLogTextType.Comment:
        return <NewsIcon className={classes.icon} />;
      case EventLogActionType.Noanswer:
        return <PhoneDisabledIcon className={classes.icon} />;
      case EventLogActionType.Email:
        return <MailIcon className={classes.icon} />;
      case EventLogActionType.SMS:
        return <ChatBubbleIcon className={classes.icon} />;
      case EventLogActionType.Interest:
        return <FavoriteIcon className={classes.icon} />;
      default:
        return undefined;
    }
  })();

  return (
    <Tooltip title={disabledReason ?? ""}>
      <span>
        <IconButton
          className={classes.button}
          onClick={() => {
            setSelected && setSelected(!selected);
            onClick && onClick();
          }}
          disabled={!!disabledReason}
        >
          {icon}
          <Typography variant="body1" className={classes.text}>
            {label}
          </Typography>
        </IconButton>
      </span>
    </Tooltip>
  );
};

const useStyles = (props: { selected: boolean; isActionButton: boolean }) =>
  makeStyles((theme) => ({
    text: {
      margin: "0 auto",
      ...(props.isActionButton
        ? { color: theme.palette.primary.main }
        : { color: props.selected ? Color.Body : Color.Gray })
    },
    icon: {
      ...(props.isActionButton
        ? { fill: theme.palette.primary.main }
        : { fill: props.selected ? Color.Body : Color.Gray })
    },
    button: {
      borderRadius: "0.25rem",
      "&:disabled": {
        opacity: 0.5
      },
      minWidth: "1rem",
      ...(props.isActionButton
        ? {
            padding: "2px 8px 2px 6px",
            backgroundColor: "transparent",
            border: `1px solid ${theme.palette.primary.main}`,
            color: theme.palette.primary.main
          }
        : {
            padding: "2px 4px 2px 2px",
            backgroundColor: props.selected ? "#ff867b26" : "transparent",
            "&:hover": {
              backgroundColor: props.selected ? "#ff867b26" : "transparent"
            }
          })
    }
  }))();
